import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Avatar,
  Badge,
  TextField,
  IconButton,
  InputAdornment,
  Paper,
  Typography,
  Divider,
  Tooltip,
  Chip,
  Fade,
  CircularProgress,
  Button,
  alpha,
} from "@mui/material";
import {
  Send as SendIcon,
  Search as SearchIcon,
  AttachFile as AttachFileIcon,
  Mood as MoodIcon,
  MoreVert as MoreVertIcon,
  Call as CallIcon,
  Videocam as VideocamIcon,
  Info as InfoIcon,
  CheckCircle as CheckCircleIcon,
  DoneAll as DoneAllIcon,
  Schedule as ScheduleIcon,
  Person as PersonIcon,
  Group as GroupIcon,
  FilterList as FilterListIcon,
  Refresh as RefreshIcon,
  Delete as DeleteIcon,
  Block as BlockIcon,
  Archive as ArchiveIcon,
  MarkChatRead as MarkChatReadIcon,
  ExpandMore as ExpandMoreIcon,
  Email,
} from "@mui/icons-material";
import axios from "axios";
import { formatDistanceToNow } from "date-fns";
import connection from "../../signalr/chatHub";
import moment from "moment";

const Messages = (props) => {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [openNewMessageModal, setOpenNewMessageModal] = useState(false);
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showPatientsList, setShowPatientsList] = useState(false);

  const messagesEndRef = useRef(null);
  const token = localStorage.getItem("Token");
  const userEmail = localStorage.getItem("Emailaddress");
  const auth = `Bearer ${token}`;
  const headers = { Authorization: auth };

  // ===================== STYLES =====================
   const styles = {
    container: {
      display: "flex",
      height: "83vh",
      marginBottom: "20px",
      marginTop: "-20px",
      backgroundColor: "#f8fafc",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      border: "1px solid #e2e8f0", // 🔹 Light border
      borderRadius: "12px", // 🔹 Smooth rounded edges
      boxShadow: "0 4px 10px rgba(0,0,0,0.05)",
    },
    sidebar: {
      width: 390,
      backgroundColor: "#ffffff",
      borderRight: "1px solid #e5e7eb",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
      overflow: "hidden",
    },
    sidebarHeader: {
      padding: "18px 16px",
      backgroundColor: "#fff",
      borderBottom: "1px solid #f1f5f9",
    },
    userProfile: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "20px",
    },
    avatarLarge: {
      width: 48,
      height: 48,
      backgroundColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      fontSize: "1.2rem",
      fontWeight: "bold",
    },
    searchBox: {
      backgroundColor: "#f8fafc",
      borderRadius: 12,
      padding: "8px 16px",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#f1f5f9",
      },
    },
    chatList: {
      flex: 1,
      overflowY: "auto",
      "&::-webkit-scrollbar": { width: "6px" },
      "&::-webkit-scrollbar-track": { background: "#f8fafc" },
      "&::-webkit-scrollbar-thumb": {
        background: "#cbd5e1",
        borderRadius: "20px",
      },
    },
    chatItem: {
      padding: "10px",
      borderBottom: "1px solid #f1f5f9",
      cursor: "pointer",
      transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      "&:hover": {
        backgroundColor: "#f8fafc",
        transform: "translateX(2px)",
      },
      "&.selected": {
        backgroundColor: "#f0f9ff",
        borderLeft: "3px solid #3b82f6",
      },
    },
    chatAvatar: {
      width: 40,
      height: 40,
      fontSize: "0.9rem",
      backgroundColor: "#8b5cf6",
    },
    chatContent: {
      padding: "12px 16px",
      borderRadius: 4,
      maxWidth: "75%",
      marginBottom: 8,
      position: "relative",
      backdropFilter: "blur(10px)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    },
    sentMessage: {
      backgroundColor: "#3b82f6",
      color: "#fff",
      marginLeft: "auto",
      // borderBottomRightRadius: 6,
    },
    receivedMessage: {
      backgroundColor: "#ffffff",
      color: "#1f2937",
      marginRight: "auto",
      border: "1px solid #e5e7eb",
      // borderBottomLeftRadius: 6,
    },
    messageInputContainer: {
      padding: "16px 20px",
      backgroundColor: "#fff",
      borderTop: "1px solid #f1f5f9",
      display: "flex",
      alignItems: "center",
      gap: "12px",
      boxShadow: "0 -2px 10px rgba(0,0,0,0.02)",
    },
    messageInput: {
      flex: 1,
      "& .MuiOutlinedInput-root": {
        borderRadius: 24,
        backgroundColor: "#f8fafc",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "#f1f5f9",
        },
        "&.Mui-focused": {
          backgroundColor: "#fff",
          boxShadow: "0 0 0 3px rgba(59, 130, 246, 0.1)",
        },
      },
    },
    sendButton: {
      backgroundColor: "#3b82f6",
      color: "#fff",
      width: 48,
      height: 48,
      "&:hover": {
        backgroundColor: "#2563eb",
        transform: "scale(1.05)",
      },
      "&.Mui-disabled": {
        backgroundColor: "#cbd5e1",
      },
      transition: "all 0.2s ease",
    },
    chatHeader: {
      backgroundColor: "#fff",
      borderBottom: "1px solid #f1f5f9",
      padding: "14px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    },
    messagesContainer: {
      flex: 1,
      padding: "24px",
      height: "calc(93vh - 140px)",
      overflowY: "auto",
      background: "linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%)",
      display: "flex",
      flexDirection: "column",
      position: "relative",
    },
    dateSeparator: {
      textAlign: "center",
      margin: "20px 0",
      position: "relative",
      "&:before": {
        content: '""',
        position: "absolute",
        top: "50%",
        left: 0,
        right: 0,
        height: "1px",
        backgroundColor: "#e5e7eb",
      },
    },
    dateLabel: {
      backgroundColor: "#fff",
      padding: "6px 16px",
      borderRadius: 16,
      border: "1px solid #e5e7eb",
      fontSize: "0.75rem",
      color: "#64748b",
      position: "relative",
      display: "inline-block",
      fontWeight: 500,
      boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    },
    loadingSpinner: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      color: "#3b82f6",
    },
    noChatSelected: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      color: "#94a3b8",
      textAlign: "center",
    },
    emojiPicker: {
      position: "absolute",
      bottom: 70,
      right: 16,
      zIndex: 1000,
      backgroundColor: "#fff",
      borderRadius: 16,
      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
      padding: "12px",
      border: "1px solid #f1f5f9",
    },
    secureBanner: {
      textAlign: "center",
      padding: "16px 0",
      fontSize: "0.95rem",
      fontWeight: "600",
      color: "#059669",
      borderBottom: "1px solid #d1fae5",
      marginBottom: "16px",
      backgroundColor: "#f0fdf4",
      borderRadius: "12px",
      margin: "0 24px 16px 24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "8px",
    },
  };

  // ===================== EFFECTS =====================
const connectionRef = useRef(connection);
const messagesRef = useRef([]);
const currentGroupRef = useRef(null);
useEffect(() => {
  messagesRef.current = messages;
}, [messages]);

const handleReceiveMessage = (msg) => {
  console.log("📩 ReceiveMessage:", msg);

  const normalized = {
    ...msg,
    description: msg.description ?? msg.body ?? "",
    clientDatetime:
      msg.clientDatetime ??
      msg.sendDate ??
      msg.createdDate,
    status: "Delivered",
    isRead: msg.isRead === true,
  };

  setMessages((prev) => {
    return [...prev, normalized];
  });

  setTimeout(scrollToBottom, 100);

  fetchChats();
};
const handleChatUpdated = () => {
  console.log("🔄 ChatUpdated");
  fetchChats();
};
const handleMessageRead = (data) => {
  console.log("👁 MessageRead", data);

  setMessages((prev) =>
    prev.map((m) =>
      data.messageIds?.includes(m.id)
        ? { ...m, isRead: true }
        : m
    )
  );
};
useEffect(() => {
  if (!selectedChat?.userEmail) return;

  const conn = connectionRef.current;

  const joinChat = async () => {
    try {
      conn.off("ReceiveMessage");
      conn.off("ChatUpdated");
      conn.off("MessageRead");

      conn.on("ReceiveMessage", handleReceiveMessage);
      conn.on("ChatUpdated", handleChatUpdated);
      conn.on("MessageRead", handleMessageRead);

      if (conn.state === "Disconnected") {
        await conn.start();
      }

      // 👇 ONE CHAT GROUP ONLY
      const newGroup = [selectedChat.userEmail]
        .map(e => e.toLowerCase().trim())
        .sort()
        .join("-");

      // 👇 leave previous group first
      if (currentGroupRef.current) {
        await conn.invoke("LeaveChatGroup", currentGroupRef.current);
      }

      await conn.invoke("JoinChatGroup", newGroup);
      await conn.invoke("JoinUser", newGroup);


      currentGroupRef.current = newGroup;

      console.log("👉 Now in group:", newGroup);

    } catch (err) {
      console.error(err);
    }
  };

  joinChat();

  return () => {
    conn.off("ReceiveMessage");
    conn.off("ChatUpdated");
    conn.off("MessageRead");
  };
}, [selectedChat, userEmail]);


useEffect(() => {
  fetchChats(); // initial call
  const interval = setInterval(() => {
    fetchChats();
  }, 30000); // 30 seconds

  return () => clearInterval(interval); 
}, [refresh]);

  useEffect(() => {
    if (selectedChat) {
      fetchConversation(selectedChat.userEmail);
    }
  }, [selectedChat]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  // ===================== API FUNCTIONS =====================
  const fetchChats = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Messages/getChats`,
        { headers }
      );

      const sortedChats = response.sort(
        (a, b) => new Date(b.LastMessageDate) - new Date(a.LastMessageDate)
      );
      setChats(sortedChats);
      const totalUnread = sortedChats.reduce(
        (sum, chat) => sum + (chat.unreadCount || 0),
        0
      );
      localStorage.setItem("unreadMessageCount", totalUnread);
    } catch (error) {
      console.error("Error fetching chats:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchConversation = async (otherEmail) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Messages/getConversationWith?otherEmail=${otherEmail}`,
        { headers }
      );

      const conversation = response.map((msg) => ({
        id: msg.id,
        sentBy: msg.sentBy,
        sentTo: msg.sentTo,
        body: msg.body,
        sendDate: msg.sendDate,
        isRead: msg.isRead,
      }));

      setMessages(conversation);
      const unreadIds = conversation
        .filter((msg) => !msg.isRead && msg.sentBy !== userEmail)
        .map((msg) => msg.id);

      if (unreadIds.length > 0) {
        await markMessagesAsRead(unreadIds);
      }
    } catch (error) {
      console.error("Error fetching conversation:", error);
    } finally {
      setLoading(false);
    }
  };

  const markMessagesAsRead = async (messageIds) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/Messages/markAsRead`,
        messageIds,
        { headers }
      );
      fetchChats(); // Refresh chat list to update unread counts
    } catch (error) {
      console.error("Error marking messages as read:", error);
    }
  };

  const sendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim()) return;

    const today = moment().format("MM/DD/YYYY HH:mm:ss");
    const messageData = {
      id: 0,
      sentBy: userEmail,
      sentTo: selectedChat.userEmail,
      body: newMessage.trim(),
      sendDate: today,
      createdBy: userEmail,
      type: "User",
      patientId: selectedChat.patientid,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/Messages/sendMessage`,
        messageData,
        { headers }
      );
      // fetchConversation(response.sentTo);
      // setRefresh(!refresh);
      setNewMessage("");
      setShowEmojiPicker(false);
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };

  const fetchPatients = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Patients/getPatients`,
        { headers }
      );
      const Patients = response.filter((row) => !!row.portalUsername);
      setPatients(Patients);
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  // ===================== HELPER FUNCTIONS =====================
  const scrollToBottom = () => {
    setTimeout(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const formatTime = (date) => {
    return moment(date).format("hh:mm");
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = moment(dateString);
    if (!date.isValid()) return "";

    const today = moment();
    const yesterday = moment().subtract(1, "days");

    if (date.isSame(today, "day")) return "Today";
    if (date.isSame(yesterday, "day")) return "Yesterday";
    return date.format("MM-DD-YYYY");
  };

  const getInitials = (email) => {
    return email?.charAt(0).toUpperCase() || "?";
  };

  const getRandomColor = (email) => {
    const colors = [
      "#8b5cf6",
      "#3b82f6",
      "#10b981",
      "#f59e0b",
      "#ef4444",
      "#ec4899",
      "#6366f1",
      "#14b8a6",
      "#f97316",
      "#84cc16",
    ];
    const index = (email?.length || 0) % colors.length;
    return colors[index];
  };

  const filteredChats = chats.filter(
    (chat) =>
      chat.userEmail?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (chat.lastMessage || "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  // ===================== EMOJIS =====================
  const emojis = [
    "😀",
    "😃",
    "😄",
    "😁",
    "😆",
    "😅",
    "😂",
    "🤣",
    "😊",
    "😇",
    "🙂",
    "🙃",
    "😉",
    "😌",
    "😍",
    "🥰",
    "😘",
    "😗",
    "😙",
    "😚",
    "😋",
    "😛",
    "😝",
    "😜",
    "🤪",
    "🤨",
    "🧐",
    "🤓",
    "😎",
    "🤩",
    "🥳",
    "😏",
    "😒",
    "😞",
    "😔",
    "😟",
    "😕",
    "🙁",
    "☹️",
    "😣",
    "😖",
    "😫",
    "😩",
    "🥺",
    "😢",
    "😭",
    "😤",
    "😠",
    "😡",
    "🤬",
    "🤯",
    "😳",
    "🥵",
    "🥶",
    "😱",
    "😨",
    "😰",
    "😥",
    "😓",
    "🤗",
    "🤔",
    "🤭",
    "🤫",
    "🤥",
    "😶",
    "😐",
    "😑",
    "😬",
    "🙄",
    "😯",
    "😦",
    "😧",
    "😮",
    "😲",
    "🥱",
    "😴",
    "🤤",
    "😪",
    "😵",
    "🤐",
    "🥴",
    "🤢",
    "🤮",
    "🤧",
    "😷",
    "🤒",
    "🤕",
    "🤑",
    "🤠",
    "😈",
  ];

  // ===================== RENDER =====================
  return (
    <div className="page-content">
      <Box style={styles.container}>
        {/* ========== SIDEBAR ========== */}
        <Box style={styles.sidebar}>
          <Box style={styles.sidebarHeader}>
            <Box style={styles.userProfile}>
              <Avatar
                sx={{
                  width: 48,
                  height: 48,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                <PersonIcon />
              </Avatar>
              <Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "#1e293b" }}
                >
                  Messages
                </Typography>
                <Typography variant="body2" sx={{ color: "#64748b" }}>
                  Secure communication
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 1}}>
              <TextField
                fullWidth
                placeholder="Search conversations..."
                variant="outlined"
                size="small"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 12,
                    backgroundColor: "#f8fafc",
                  },
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "#94a3b8" }} />
                    </InputAdornment>
                  ),
                }}
              />
             <Tooltip title="Add New Conversation">
    <Button
      onClick={() => {
        setShowPatientsList(!showPatientsList);
        fetchPatients();
      }}
      sx={{
        backgroundColor: "#f0f9ff",
        "&:hover": { backgroundColor: "#e0f2fe" },
        flexDirection: "column", // icon ke upar label
        px: 1,
        py: 0.5,
      }}
    >
      <GroupIcon sx={{ color: "#0ea5e9", fontSize: 24 }} />
      <Typography variant="caption" sx={{ fontSize: 10 }}>
        New Message
      </Typography>
    </Button>
  </Tooltip>
            </Box>
          </Box>

          {showPatientsList && patients.length > 0 && (
            <Paper sx={{ mx: 2, mb: 2, borderRadius: 2, overflow: "hidden" }}>
              <Typography
                sx={{ p: 2, pb: 1, fontWeight: 600, color: "#475569" }}
              >
                Select Patient
              </Typography>
              <List sx={{ maxHeight: 200, overflowY: "auto" }}>
                {patients.map((patient) => (
                  <ListItem
                    key={patient.id}
                    onClick={() => {
                      setSelectedChat({
                        userEmail: patient.emailAddress,
                        patientid: patient.id,
                        name: patient.portalUsername,
                      });
                      setSelectedPatient(patient);
                      setShowPatientsList(false);
                    }}
                    sx={{
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#f8fafc" },
                    }}
                  >
                    <ListItemAvatar>
                      <Avatar
                        sx={{
                          backgroundColor: getRandomColor(patient.emailAddress),
                          fontSize: "0.9rem",
                        }}
                      >
                        {getInitials(patient.firstName + patient.lastName)}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={`${patient.firstName} ${patient.lastName}`}
                      secondary={patient.emailAddress}
                      primaryTypographyProps={{ fontWeight: 500 }}
                      secondaryTypographyProps={{
                        fontSize: "0.8rem",
                        color: "#64748b",
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Paper>
          )}

          <List style={styles.chatList}>
            {loading && !chats.length ? (
              <Box style={styles.loadingSpinner}>
                <CircularProgress size={32} />
              </Box>
            ) : filteredChats.length === 0 ? (
              <Box sx={{ textAlign: "center", color: "#94a3b8" }}>
                <GroupIcon sx={{ fontSize: 48, opacity: 0.5 }} />
                <Typography>No conversations yet</Typography>
              </Box>
            ) : (
              filteredChats.map((chat) => (
                <ListItem
                  key={chat.userEmail}
                  onClick={() => setSelectedChat(chat)}
                  sx={{
                    ...styles.chatItem,
                    backgroundColor:
                      selectedChat?.userEmail === chat.userEmail
                        ? "#f0f9ff"
                        : "transparent",
                    borderLeft:
                      selectedChat?.userEmail === chat.userEmail
                        ? "3px solid #3b82f6"
                        : "none",
                  }}
                >
                  <ListItemAvatar>
                    <Badge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      variant="dot"
                      color={chat.online ? "success" : "default"}
                    >
                      <Avatar
                        sx={{
                          backgroundColor: getRandomColor(chat.userEmail),
                          fontSize: "0.9rem",
                          fontWeight: 600,
                        }}
                      >
                        {getInitials(chat.userEmail)}
                      </Avatar>
                    </Badge>
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        sx={{ minWidth: 0 }} // ← IMPORTANT
                      >
                        {/* Email (truncate if long) */}
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: "#1e293b",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            maxWidth: "65%", // ← space limit so time never overlaps
                          }}
                        >
                          {chat.patientName ? chat.patientName : chat.userEmail}
                        </Typography>

                        {/* Time (fixed width, no overlap) */}
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#94a3b8",
                            whiteSpace: "nowrap",
                            marginLeft: "8px",
                            flexShrink: 0, // ← never shrink
                          }}
                        >
                          {formatDate(chat.lastMessageDate)}
                        </Typography>
                      </Box>
                    }
                    secondary={
                      <Box>
                        {/* <Box display="flex" justifyContent="flex-end">
                        <Typography
                          variant="caption"
                          justifyContent="flex-end"
                          sx={{
                            color: "#94a3b8",
                          }}
                        >
                          {formatDistanceToNow(new Date(chat.lastMessageDate), {
                            addSuffix: true,
                          })}
                        </Typography>
                        </Box> */}
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#64748b",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "200px",
                            }}
                          >
                            {chat.lastMessage || "No messages yet"}
                          </Typography>

                          {chat.unreadCount > 0 && (
                            <Chip
                              label={chat.unreadCount}
                              size="small"
                              sx={{
                                backgroundColor: "#3b82f6",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "0.7rem",
                                height: 20,
                                minWidth: 20,
                              }}
                            />
                          )}
                        </Box>
                      </Box>
                    }
                  />
                </ListItem>
              ))
            )}
          </List>
        </Box>

        {/* ========== MAIN CHAT AREA ========== */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
          }}
        >
          {/* Chat Header */}
          {selectedChat ? (
            <Box style={styles.chatHeader}>
              <Box display="flex" alignItems="center" gap={2}>
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  variant="dot"
                  color="success"
                >
                  <Avatar
                    sx={{
                      backgroundColor: getRandomColor(selectedChat.userEmail),
                      fontSize: "1rem",
                      fontWeight: 600,
                    }}
                  >
                    {getInitials(selectedChat.userEmail)}
                  </Avatar>
                </Badge>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, color: "#1e293b" }}
                  >
                    {selectedChat.patientName
                      ? selectedChat.patientName
                      : selectedChat.userEmail}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "#64748b", fontSize: "0.875rem" }}
                  >
                    Secure messaging
                  </Typography>
                </Box>
              </Box>
              <Box display="flex" gap={1}>
                <Tooltip title="Refresh">
                  <IconButton
                    onClick={() => setRefresh(!refresh)}
                    sx={{ color: "#64748b" }}
                  >
                    <RefreshIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          ) : (
            <Box style={styles.chatHeader}>
              <Typography
                variant="h6"
                sx={{ fontWeight: 700, color: "#94a3b8" }}
              >
                Select a conversation
              </Typography>
            </Box>
          )}

          {/* Secure Banner */}
          <Box style={styles.secureBanner}>
            <CheckCircleIcon sx={{ fontSize: 18 }} />
            <Typography>You Are Communicating Securely</Typography>
          </Box>

          {/* Messages Container */}
          <Box style={styles.messagesContainer}>
            {!selectedChat ? (
              <Box style={styles.noChatSelected}>
                <GroupIcon sx={{ fontSize: 72, mb: 2, color: "#cbd5e1" }} />
                <Typography variant="h6" sx={{ color: "#94a3b8", mb: 1 }}>
                  Welcome to Secure Messages
                </Typography>
                <Typography sx={{ color: "#94a3b8", maxWidth: 400 }}>
                  Select a conversation from the sidebar or start a new one
                </Typography>
              </Box>
            ) : loading && !messages.length ? (
              <Box style={styles.loadingSpinner}>
                <CircularProgress size={40} />
              </Box>
            ) : messages.length === 0 ? (
              <Box style={styles.noChatSelected}>
                <Typography sx={{ color: "#94a3b8" }}>
                  No messages yet. Start the conversation!
                </Typography>
              </Box>
            ) : (
              <>
                {messages.map((message, index) => {
                  const isMine = message.sentBy === userEmail;
                  const showDate =
                    index === 0 ||
                    formatDate(messages[index - 1].sendDate) !==
                      formatDate(message.sendDate);

                  return (
                    <React.Fragment key={message.id}>
                      {showDate && (
                        <Box style={styles.dateSeparator}>
                          <Chip
                            label={formatDate(message.sendDate)}
                            style={styles.dateLabel}
                          />
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: isMine ? "flex-end" : "flex-start",
                          mb: 2,
                          px: 1,
                        }}
                      >
                        <Paper
                          elevation={0}
                          sx={{
                            ...styles.chatContent,
                            backgroundColor: isMine ? "#3b82f6" : "#ffffff",
                            color: isMine ? "#fff" : "#1f2937",
                            // border: isMine ? "none" : "1px solid #e5e7eb",
                            maxWidth: { xs: "85%", sm: "75%", md: "65%" },
                          }}
                        >
                          {!isMine && (
                            <Typography
                              variant="caption"
                              sx={{
                                display: "block",
                                mb: 0.5,
                                color: isMine
                                  ? "rgba(255,255,255,0.9)"
                                  : "#6b7280",
                                fontWeight: 500,
                                fontSize: "0.7rem",
                              }}
                            >
                              {message.sentBy}
                            </Typography>
                          )}
                          <Typography
                            sx={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                              fontSize: "0.95rem",
                              lineHeight: 1.5,
                            }}
                          >
                            {message.body}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              mt: 1,
                              fontSize: "0.75rem",
                              color: isMine
                                ? "rgba(255,255,255,0.8)"
                                : "#6b7280",
                            }}
                          >
                            <span>{formatTime(message.sendDate)}</span>
                            {isMine && (
                              <Box sx={{ ml: 1 }}>
                                {message.isRead ? (
                                  <DoneAllIcon
                                    sx={{
                                      fontSize: 16,
                                      color: "rgba(255,255,255,0.9)",
                                    }}
                                  />
                                ) : (
                                  <CheckCircleIcon
                                    sx={{ fontSize: 16, opacity: 0.7 }}
                                  />
                                )}
                              </Box>
                            )}
                          </Box>
                        </Paper>
                      </Box>
                    </React.Fragment>
                  );
                })}
                <div ref={messagesEndRef} />
              </>
            )}
          </Box>

          {/* Message Input */}
          {selectedChat && (
            <Box
              component="form"
              onSubmit={sendMessage}
              style={styles.messageInputContainer}
            >
              <TextField
                fullWidth
                placeholder="Type your secure message..."
                variant="outlined"
                size="medium"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                sx={styles.messageInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Tooltip title="Emoji">
                        <IconButton
                          onClick={() => setShowEmojiPicker(!showEmojiPicker)}
                          sx={{ color: "#64748b" }}
                        >
                          <MoodIcon />
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  ),
                }}
                disabled={loading}
              />
              <IconButton
                type="submit"
                sx={styles.sendButton}
                disabled={!newMessage.trim() || loading}
              >
                <SendIcon />
              </IconButton>

              {showEmojiPicker && (
                <Fade in={showEmojiPicker}>
                  <Paper sx={styles.emojiPicker}>
                    <Box
                      display="flex"
                      flexWrap="wrap"
                      gap={0.5}
                      sx={{
                        width: 260,
                        maxHeight: 220,
                        overflowY: "auto",
                        p: 0.5,
                      }}
                    >
                      {emojis.map((emoji, index) => (
                        <IconButton
                          key={index}
                          onClick={() => {
                            setNewMessage((prev) => prev + emoji);
                            setShowEmojiPicker(false);
                          }}
                          sx={{
                            fontSize: "1.5rem",
                            width: 36,
                            height: 36,
                            "&:hover": { transform: "scale(1.2)" },
                            transition: "transform 0.2s ease",
                          }}
                        >
                          {emoji}
                        </IconButton>
                      ))}
                    </Box>
                  </Paper>
                </Fade>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default Messages;
